import { render, staticRenderFns } from "./SubscribeSidebar.vue?vue&type=template&id=f884dcdc&scoped=true"
import script from "./SubscribeSidebar.vue?vue&type=script&lang=js"
export * from "./SubscribeSidebar.vue?vue&type=script&lang=js"
import style0 from "./SubscribeSidebar.vue?vue&type=style&index=0&id=f884dcdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f884dcdc",
  null
  
)

export default component.exports